module.exports = __webpack_public_path__ + "img/scancodebg.37fa1765.png";